export default (value: string) =>
  /^#{1}[0-9A-F]{6}$|^#{1}[0-9A-F]{3}$/gi.test(value);
